import React from 'react';
import { 
  FaBullseye, FaEye, FaHandshake, FaChartLine, FaUserTie,   
  FaChartPie, FaLightbulb, FaLandmark, FaHome, FaUsers, FaCheckCircle
} from 'react-icons/fa';
import { Helmet } from 'react-helmet-async';
const AboutUs = () => {
  return (
    <main>

      <Helmet>
        {/* Basic SEO */}
        <title>About Lotoswealth | Wealth Management Experts in Hyderabad | Financial Advisors</title>

        <meta
          name="description"
          content="Learn about Lotoswealth, a trusted wealth management and financial advisory firm in Hyderabad. We specialize in Wealth Management, Portfolio Management Services (PMS), Financial Planning, Tax Planning, Mutual Funds, Stock Investments, Retirement Planning, Estate Planning, Asset Management, and personalized investment solutions."
        />

        <meta
          name="keywords"
          content="About Lotoswealth, Lotoswealth Hyderabad, Wealth Management Experts Hyderabad, Financial Advisors Hyderabad, Investment Advisors Hyderabad, Wealth Management Services Hyderabad, Portfolio Management Services Hyderabad, PMS Hyderabad, Financial Planning Hyderabad, Tax Planning Hyderabad, Estate Planning Hyderabad, Retirement Planning Hyderabad, Asset Management Hyderabad, Mutual Funds Hyderabad, Stocks Investment Hyderabad, Alternative Investments Hyderabad, Private Equity Hyderabad, Private Credit Hyderabad, Offshore Investments Hyderabad, Wealth Advisory Hyderabad, Financial Services Hyderabad"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="Lotoswealth" />
        <meta name="language" content="English" />

        <link rel="canonical" href="https://www.lotoswealth.com/about-us" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Lotoswealth" />
        <meta property="og:url" content="https://www.lotoswealth.com/about-us" />
        <meta
          property="og:title"
          content="About Lotoswealth | Wealth Management Experts in Hyderabad"
        />
        <meta
          property="og:description"
          content="Discover Lotoswealth, your trusted partner for Wealth Management, Portfolio Management Services (PMS), Financial Planning, Tax Planning, Mutual Funds, Retirement Planning, and Investment Advisory in Hyderabad."
        />
        <meta
          property="og:image"
          content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="About Lotoswealth | Wealth Management Experts in Hyderabad"
        />
        <meta
          name="twitter:description"
          content="Learn more about Lotoswealth, providing trusted Wealth Management, Financial Planning, Investment Advisory, Portfolio Management Services, and Asset Management in Hyderabad."
        />
        <meta
          name="twitter:image"
          content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
        />
      </Helmet>
      {/* =========================================
          HERO SECTION (Matches image_80bc69.jpg)
      ========================================= */}
      <div className="hero-wrapper position-relative" style={{ height: '100vh', minHeight: '800px', overflow: 'hidden' }}>
        
       <div className="position-absolute top-0 start-0 w-100 h-100 z-0 animate-slow-zoom">
          <img 
            src="/images/aboutus.jpg" 
            alt="About LotosWealth" 
            className="w-100 h-100 object-fit-cover"
          />
        </div>

        {/* Slanted Panels Overlay (Empty, just providing color overlays) */}
        <div className="panels-container position-absolute top-0 start-0 w-100 h-100 z-1 d-flex">
          <div className="slanted-panel panel-1"></div>
          <div className="slanted-panel panel-2"></div>
          <div className="slanted-panel panel-3"></div>
          <div className="slanted-panel panel-4"></div>
        </div>

        {/* --- Floating Main Header Text (Perfectly Centered) --- */}
        <div className="container hero-main-text text-center position-absolute top-50 start-50 translate-middle z-3 w-100 px-4">
          <h1 className="fw-bold display-4 animate-slide-up delay-1 mb-3 text-white d-flex align-items-center justify-content-center gap-3" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
            <span style={{ color: '#a3e635' }}>🌿</span> About LotosWealth
          </h1>
          <h2 className="animate-slide-up delay-2 fw-bold text-white mb-4" style={{ textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Trusted Wealth Management & Investment Solutions
          </h2>
          <p className="hero-description animate-slide-up delay-3 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
             At Lotoswealth, we are committed to helping individuals, families, and businesses achieve long-term financial success through smart investment strategies and personalized wealth management solutions. Our mission is to simplify investing while building lasting relationships based on trust, transparency, and performance.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-4 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
             With a client-first approach, we offer comprehensive financial services designed to meet your unique goals. Whether you're planning for retirement, growing your investment portfolio, preserving your wealth, or exploring new financial opportunities, our experienced professionals provide expert guidance every step of the way.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-5 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
             We believe that every financial journey is unique. That's why we take the time to understand your objectives, risk tolerance, and future aspirations before creating customized investment strategies tailored to your needs.
          </p>
        </div>

        {/* --- Scrolling Stock Ticker --- */}
        <div className="stock-ticker position-absolute bottom-0 w-100 z-3 bg-dark text-white border-top border-bottom border-secondary py-2" style={{ opacity: 0.9 }}>
          <div className="ticker-track">
            {/* First Set */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
            
            {/* Duplicated Set for Seamless Infinite Scrolling */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
          </div>
        </div>

      </div>

      {/* =========================================
          PAGE CONTENT SECTIONS
      ========================================= */}

       {/* --- 2. Vision & Mission Section --- */}
      <section className="py-5 bg-white">
        <div className="container py-4">
          <div className="row g-4">
            {/* Vision */}
            <div className="col-md-6 animate-slide-up delay-2">
              <div className="card h-100 border-0 shadow-sm p-4 hover-lift-card">
                <div className="card-body text-center">
                  <div className="icon-circle bg-teal-light text-teal mb-4 mx-auto">
                    <FaEye size={32} />
                  </div>
                  <h3 className="fw-bold mb-3">🎯 Our Vision</h3>
                  <p className="text-muted">
                    To become India's most trusted wealth management partner by delivering transparent, innovative, and personalized financial solutions that empower every client to achieve financial freedom.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Mission */}
            <div className="col-md-6 animate-slide-up delay-3">
              <div className="card h-100 border-0 shadow-sm p-4 hover-lift-card">
                <div className="card-body text-center">
                  <div className="icon-circle bg-teal-light text-teal mb-4 mx-auto">
                    <FaBullseye size={32} />
                  </div>
                  <h3 className="fw-bold mb-3">🚀 Our Mission</h3>
                  <p className="text-muted">
                    Our mission is to simplify finance through trusted advice, intelligent investment strategies, and comprehensive financial planning while creating long-term value for our clients and their families.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- 3. Core Values Section --- */}
      <section className="py-5 bg-light">
        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold">💡 Our Core Values</h2>
          </div>
          <div className="row g-4 justify-content-center text-center">
            <div className="col-lg-4 col-md-6 animate-slide-up delay-2">
              <div className="p-4 bg-white shadow-sm rounded h-100 border-bottom border-teal border-4 hover-lift-card">
                <FaHandshake size={40} className="text-teal mb-3" />
                <h5 className="fw-bold">Trust & Integrity</h5>
                <p className="text-muted small">Lasting relationships are built on honesty, transparency, and ethical financial practices.</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 animate-slide-up delay-3">
              <div className="p-4 bg-white shadow-sm rounded h-100 border-bottom border-teal border-4 hover-lift-card">
                <FaUsers size={40} className="text-teal mb-3" />
                <h5 className="fw-bold">Client First</h5>
                <p className="text-muted small">Every recommendation we make is driven by your financial goals—not sales targets.</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 animate-slide-up delay-4">
              <div className="p-4 bg-white shadow-sm rounded h-100 border-bottom border-teal border-4 hover-lift-card">
                <FaChartLine size={40} className="text-teal mb-3" />
                <h5 className="fw-bold">Excellence</h5>
                <p className="text-muted small">We continuously improve our research, technology, and advisory services to deliver exceptional outcomes.</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 animate-slide-up delay-5">
              <div className="p-4 bg-white shadow-sm rounded h-100 border-bottom border-teal border-4 hover-lift-card">
                <FaUserTie size={40} className="text-teal mb-3" />
                <h5 className="fw-bold">Professional Expertise</h5>
                <p className="text-muted small">Our experienced professionals stay updated with changing markets, regulations, and investment opportunities.</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 animate-slide-up delay-6">
              <div className="p-4 bg-white shadow-sm rounded h-100 border-bottom border-teal border-4 hover-lift-card">
                <FaChartPie size={40} className="text-teal mb-3" />
                <h5 className="fw-bold">Long-Term Relationships</h5>
                <p className="text-muted small">We measure our success by the financial success of our clients.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- 4. Why Choose Us Section --- */}
      <section className="py-5 bg-dark text-white">
        <div className="container py-5">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-white">🌟 Why Choose LotosWealth?</h2>
          </div>
          <div className="row g-4">
            <div className="col-md-6 col-lg-4 animate-slide-up delay-2">
              <h5 className="fw-bold text-teal-light">🎯 Personalized Solutions</h5>
              <p className="text-light opacity-75 small">No two investors are alike. We create tailored financial strategies designed around your income, lifestyle, goals, and risk tolerance.</p>
            </div>
            <div className="col-md-6 col-lg-4 animate-slide-up delay-3">
              <h5 className="fw-bold text-teal-light">📈 Research-Driven Advice</h5>
              <p className="text-light opacity-75 small">Our investment recommendations are backed by detailed market analysis, economic research, and disciplined portfolio management.</p>
            </div>
            <div className="col-md-6 col-lg-4 animate-slide-up delay-4">
              <h5 className="fw-bold text-teal-light">🛡️ Complete Wealth Protection</h5>
              <p className="text-light opacity-75 small">Growing wealth is important—but protecting it is equally essential. We help secure your financial future through risk management.</p>
            </div>
            <div className="col-md-6 col-lg-4 animate-slide-up delay-5">
              <h5 className="fw-bold text-teal-light">🌍 Comprehensive Services</h5>
              <p className="text-light opacity-75 small">From investments and retirement planning to loans and tax optimization, everything is available under one trusted partner.</p>
            </div>
            <div className="col-md-6 col-lg-4 animate-slide-up delay-6">
              <h5 className="fw-bold text-teal-light">💬 Transparent Advisory</h5>
              <p className="text-light opacity-75 small">We believe in complete transparency with clear communication, honest advice, and no hidden surprises.</p>
            </div>
            <div className="col-md-6 col-lg-4 animate-slide-up delay-7">
              <h5 className="fw-bold text-teal-light">🤝 Dedicated Support</h5>
              <p className="text-light opacity-75 small">Our advisors stay connected with you throughout your financial journey, ensuring your strategy evolves as your life changes.</p>
            </div>
          </div>
        </div>
      </section>

      {/* --- 5. Our Services Section --- */}
      <section className="py-5 bg-white">
        <div className="container py-5">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold">💼 Our Services</h2>
            <p className="text-muted">We offer end-to-end financial solutions that help you build, grow, manage, and preserve your wealth.</p>
          </div>

          <div className="row g-4">
            
            <div className="col-lg-4 col-md-6 animate-slide-up delay-2">
              <div className="card h-100 border-0 shadow-sm p-4 bg-light hover-lift-card">
                <FaChartPie size={32} className="text-teal mb-3" />
                <h4 className="fw-bold mb-3">💎 Wealth Management</h4>
                <p className="text-muted small mb-3">Designed to help you create sustainable long-term wealth while balancing growth and risk.</p>
                <ul className="text-muted text-start ps-3 fs-6 small">
                  <li className="mb-1">Portfolio Management (PMS)</li>
                  <li className="mb-1">Tax & Estate Planning</li>
                  <li className="mb-1">Offshore Investments</li>
                  <li className="mb-1">Alternative Investments</li>
                  <li className="mb-1">Private Equity & Credit</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-3">
              <div className="card h-100 border-0 shadow-sm p-4 bg-light hover-lift-card">
                <FaLightbulb size={32} className="text-teal mb-3" />
                <h4 className="fw-bold mb-3">📋 Financial Planning</h4>
                <p className="text-muted small mb-3">Financial success begins with a well-defined roadmap. We help you prepare for every stage of life.</p>
                <ul className="text-muted text-start ps-3 fs-6 small">
                  <li className="mb-1">Goal-Based Investing</li>
                  <li className="mb-1">Retirement & Post-Retirement</li>
                  <li className="mb-1">FIRE Planning</li>
                  <li className="mb-1">Corporate Financial Wellness</li>
                  <li className="mb-1">Wealth Transfer Planning</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-4">
              <div className="card h-100 border-0 shadow-sm p-4 bg-light hover-lift-card">
                <FaLandmark size={32} className="text-teal mb-3" />
                <h4 className="fw-bold mb-3">📊 Asset Management</h4>
                <p className="text-muted small mb-3">Focusing on preserving capital while maximizing returns through disciplined strategies.</p>
                <ul className="text-muted text-start ps-3 fs-6 small">
                  <li className="mb-1">Strategic Asset Allocation</li>
                  <li className="mb-1">Portfolio Diversification</li>
                  <li className="mb-1">Wealth Protection Strategies</li>
                  <li className="mb-1">Family Office Services</li>
                  <li className="mb-1">Performance Monitoring</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 animate-slide-up delay-5">
              <div className="card h-100 border-0 shadow-sm p-4 bg-light hover-lift-card">
                <FaChartLine size={32} className="text-teal mb-3" />
                <h4 className="fw-bold mb-3">📈 Investment Solutions</h4>
                <p className="text-muted small mb-3">Build a diversified portfolio with access to carefully selected opportunities backed by professional research.</p>
                <ul className="text-muted text-start ps-3 fs-6 small">
                  <li className="mb-1">Direct Stocks & Equity</li>
                  <li className="mb-1">Curated Mutual Funds</li>
                  <li className="mb-1">Portfolio Management Services (PMS)</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-6 col-md-12 animate-slide-up delay-6">
              <div className="card h-100 border-0 shadow-sm p-4 bg-light hover-lift-card">
                <FaHome size={32} className="text-teal mb-3" />
                <h4 className="fw-bold mb-3">🏦 Loan Solutions</h4>
                <p className="text-muted small mb-3">Secure the right financing with competitive rates, quick approvals, and minimal documentation.</p>
                <div className="row">
                  <div className="col-sm-6">
                    <ul className="text-muted text-start ps-3 fs-6 small">
                      <li className="mb-1">Home & Car Loans</li>
                      <li className="mb-1">Education Loans</li>
                    </ul>
                  </div>
                  <div className="col-sm-6">
                    <ul className="text-muted text-start ps-3 fs-6 small">
                      <li className="mb-1">Loan Against Property</li>
                      <li className="mb-1">Business Loans</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* --- 6. Final Commitment CTA --- */}
      <section className="py-5 bg-light text-center border-top">
        <div className="container py-5">
          <h2 className="fw-bold mb-4 animate-slide-up delay-1">📌 Our Commitment</h2>
          <p className="text-muted mx-auto mb-5 animate-slide-up delay-2" style={{ maxWidth: '800px', lineHeight: '1.8' }}>
            At LotosWealth, we are committed to providing trusted financial guidance that empowers our clients to make informed decisions with confidence. Whether your goal is to grow wealth, plan for retirement, save taxes, diversify globally, finance your dreams, or secure your family's future, our experienced advisors are here to support you every step of the way. We don't just manage investments—we build lifelong financial partnerships based on trust, expertise, and measurable results.
          </p>
          
          <div className="p-4 bg-white rounded shadow-sm d-inline-block text-start animate-slide-up delay-3 mx-auto">
            <h5 className="fw-bold mb-3 text-center">🌟 Why Thousands Choose LotosWealth</h5>
            <div className="row">
              <div className="col-md-6">
                <ul className="list-unstyled mb-0">
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" /> Personalized Financial Planning</li>
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" /> Comprehensive Wealth Management</li>
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" /> Expert Investment Advisory</li>
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" /> Tax-Efficient Wealth Strategies</li>
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" /> Transparent Financial Guidance</li>
                </ul>
              </div>
              <div className="col-md-6">
                <ul className="list-unstyled mb-0">
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" /> Professional Portfolio Management</li>
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" /> Retirement & Legacy Planning</li>
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" /> Quick & Easy Loan Solutions</li>
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" /> Client-First Advisory Approach</li>
                  <li className="mb-2"><FaCheckCircle className="text-success me-2" /> Long-Term Wealth Creation</li>
                </ul>
              </div>
            </div>
          </div>
          
          <div className="mt-5 animate-slide-up delay-4">
            <h3 className="fw-bold text-teal mb-3">💚 Your Financial Journey Starts Here</h3>
            <p className="text-muted">Grow. Protect. Prosper. <br /><strong>LotosWealth — Building Wealth, Securing Futures.</strong></p>
            <button className="btn-custom-teal hover-lift mt-3 px-5 py-3 fs-5 border-0 rounded text-white shadow">Contact an Advisor Today</button>
          </div>
        </div>
      </section>
    </main>
  );
};

export default AboutUs;